query getTopics {
  topics: getActiveTopics {
    id
    name
    description
    isSystemGenerated
    createdAt
    visibility {
      contentCreator
      topics
      acquisitionBooster
      materialUploads
    }
    landingpage {
      id
      type
      slug
      name
      status
      url
    }
  }
}
